import React from "react";
import * as dc from "dc";
import { TagTemplate } from "./tagTemplate";
import './tag.css';

const barChartFunc = (divRef, ndx, tags, index) => {
    const myChart = dc.cboxMenu(divRef);//dc.rowChart(divRef);

    const dimension = ndx.dimension(function (d) {
      d.tag.length = tags.length;
      return d.tag[index];
    });

  myChart
    .dimension(dimension)
    .group(dimension.group())
    .multiple(true)
    //.numberVisible(10)
    //.controlsUseVisibility(true)


    return myChart
}

let index;

export class TagChart extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
      <TagTemplate chartFunction={barChartFunc} index={this.props.index}
         type={this.props.type}/>
    );
  }
}
